import { initialOpenModalWithPromise, useOpenModalWithPromise } from '../hooks/useOpenModalWithPromise';
import { Modals } from '../types';
export const useCreateModalsForContext = _ref => {
  let {
    setActiveModal,
    onInstallationCompleted
  } = _ref;
  const commonProps = {
    setActiveModal,
    onInstallationCompleted
  };
  const userConsentModal = useOpenModalWithPromise({
    ...commonProps,
    modal: Modals.userConsent
  });
  const upgradeToPremiumModal = useOpenModalWithPromise({
    ...commonProps,
    modal: Modals.upgradeToPremium
  });
  const connectDomainModal = useOpenModalWithPromise({
    ...commonProps,
    modal: Modals.connectDomain
  });
  const siteSelectorModal = useOpenModalWithPromise({
    ...commonProps,
    modal: Modals.siteSelector
  });
  const errorModal = useOpenModalWithPromise({
    ...commonProps,
    modal: Modals.error
  });
  const businessFirstModal = useOpenModalWithPromise({
    ...commonProps,
    modal: Modals.businessFirst
  });
  const devModalSiteSelectorModal = useOpenModalWithPromise({
    ...commonProps,
    modal: Modals.devModeSiteSelector
  });
  const incompatibleAppModal = useOpenModalWithPromise({
    ...commonProps,
    modal: Modals.incompatibleApp
  });
  const updateAppSuccessModal = useOpenModalWithPromise({
    ...commonProps,
    modal: Modals.updateAppSuccess
  });
  return {
    error: errorModal,
    userConsent: userConsentModal,
    siteSelector: siteSelectorModal,
    connectDomain: connectDomainModal,
    businessFirst: businessFirstModal,
    incompatibleApp: incompatibleAppModal,
    updateAppSuccess: updateAppSuccessModal,
    upgradeToPremium: upgradeToPremiumModal,
    devModalSiteSelector: devModalSiteSelectorModal
  };
};
export const initModalsData = {
  error: initialOpenModalWithPromise,
  userConsent: initialOpenModalWithPromise,
  siteSelector: initialOpenModalWithPromise,
  connectDomain: initialOpenModalWithPromise,
  businessFirst: initialOpenModalWithPromise,
  incompatibleApp: initialOpenModalWithPromise,
  updateAppSuccess: initialOpenModalWithPromise,
  upgradeToPremium: initialOpenModalWithPromise,
  devModalSiteSelector: initialOpenModalWithPromise
};
//# sourceMappingURL=useCreateModalsForContext.js.map